import React from 'react';
import { Download, Youtube, ExternalLink, Smartphone, Info } from 'lucide-react';

export const Android15Alert = () => {
  return (
    <section
      style={{
        background: 'var(--bg-secondary)',
        padding: '60px 0',
        marginTop: '60px',
        borderTop: '1px solid var(--border-subtle)',
        borderBottom: '1px solid var(--border-subtle)',
      }}
    >
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 7.6923%',
        }}
      >
        {/* Title */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px',
            }}
          >
            <Smartphone size={32} color="var(--brand-primary)" />
            <h2
              style={{
                fontSize: '36px',
                fontWeight: 600,
                lineHeight: 1.1,
                color: 'var(--text-primary)',
                margin: 0,
              }}
            >
              Untuk Pengguna Android 15+
            </h2>
          </div>
          <p
            style={{
              fontSize: '18px',
              color: 'var(--text-secondary)',
              maxWidth: '700px',
              margin: '0 auto',
            }}
          >
            Pastikan install 2 aplikasi pendukung ini terlebih dahulu sebelum menginstall BAiBOT
          </p>
        </div>

        {/* Apps Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '32px',
            marginBottom: '40px',
          }}
        >
          {/* BAINSTALLER */}
          <div
            className="dark-hover"
            style={{
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-subtle)',
              padding: '32px',
              textAlign: 'center',
              transition: 'all 0.4s ease-in-out',
            }}
          >
            <div
              style={{
                width: '64px',
                height: '64px',
                background: 'var(--brand-primary)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
              }}
            >
              <Download size={32} color="#000000" />
            </div>
            <h3
              style={{
                fontSize: '22px',
                fontWeight: 600,
                color: 'var(--text-primary)',
                marginBottom: '12px',
              }}
            >
              BAINSTALLER
            </h3>
            <p
              style={{
                fontSize: '16px',
                color: 'var(--text-secondary)',
                marginBottom: '24px',
                lineHeight: 1.5,
              }}
            >
              Aplikasi installer khusus untuk Android 15 ke atas
            </p>
            <a
              href="https://baiclopz.cloud/Baiclopz/apk/bainstaller.apk"
              className="btn-primary"
              style={{
                width: '100%',
                textDecoration: 'none',
              }}
            >
              <Download size={18} />
              Download BAINSTALLER
            </a>
          </div>

          {/* Shizuku */}
          <div
            className="dark-hover"
            style={{
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-subtle)',
              padding: '32px',
              textAlign: 'center',
              transition: 'all 0.4s ease-in-out',
            }}
          >
            <div
              style={{
                width: '64px',
                height: '64px',
                background: 'var(--brand-primary)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
              }}
            >
              <ExternalLink size={32} color="#000000" />
            </div>
            <h3
              style={{
                fontSize: '22px',
                fontWeight: 600,
                color: 'var(--text-primary)',
                marginBottom: '12px',
              }}
            >
              Shizuku
            </h3>
            <p
              style={{
                fontSize: '16px',
                color: 'var(--text-secondary)',
                marginBottom: '24px',
                lineHeight: 1.5,
              }}
            >
              Framework untuk izin sistem Android 15 ke atas
            </p>
            <a
              href="https://shizuku.rikka.app/download/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
              style={{
                width: '100%',
                textDecoration: 'none',
              }}
            >
              <ExternalLink size={18} />
              Download Shizuku
            </a>
          </div>

          {/* Tutorial */}
          <div
            className="dark-hover"
            style={{
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-subtle)',
              padding: '32px',
              textAlign: 'center',
              transition: 'all 0.4s ease-in-out',
            }}
          >
            <div
              style={{
                width: '64px',
                height: '64px',
                background: 'var(--brand-primary)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
              }}
            >
              <Youtube size={32} color="#000000" />
            </div>
            <h3
              style={{
                fontSize: '22px',
                fontWeight: 600,
                color: 'var(--text-primary)',
                marginBottom: '12px',
              }}
            >
              Tutorial Instalasi
            </h3>
            <p
              style={{
                fontSize: '16px',
                color: 'var(--text-secondary)',
                marginBottom: '24px',
                lineHeight: 1.5,
              }}
            >
              Panduan lengkap cara instalasi untuk Android 15+
            </p>
            <a
              href="https://youtu.be/r-Bjo35CUdk"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{
                width: '100%',
                textDecoration: 'none',
              }}
            >
              <Youtube size={18} />
              Tonton Tutorial
            </a>
          </div>
        </div>

        {/* Info Box */}
        <div
          style={{
            background: 'rgba(0, 255, 209, 0.05)',
            border: '1px solid rgba(0, 255, 209, 0.2)',
            padding: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <Info size={24} color="var(--brand-primary)" style={{ flexShrink: 0 }} />
          <p
            style={{
              fontSize: '16px',
              color: 'var(--text-secondary)',
              margin: 0,
              lineHeight: 1.5,
            }}
          >
            <strong style={{ color: 'var(--brand-primary)' }}>Cara cek versi Android Anda:</strong> Buka{' '}
            <strong>Pengaturan → Tentang Ponsel → Versi Android</strong>
          </p>
        </div>
      </div>
    </section>
  );
};
